import { render, staticRenderFns } from "./shipmentsByVolume.vue?vue&type=template&id=4feee40e"
import script from "./shipmentsByVolume.vue?vue&type=script&lang=js"
export * from "./shipmentsByVolume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4feee40e')) {
      api.createRecord('4feee40e', component.options)
    } else {
      api.reload('4feee40e', component.options)
    }
    module.hot.accept("./shipmentsByVolume.vue?vue&type=template&id=4feee40e", function () {
      api.rerender('4feee40e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Distribution/shipmentsByVolume.vue"
export default component.exports